import { LazyString } from './LazyString';

export { LazyString };
export const lazyGettext = (msgid, interpolation) => {
    return new LazyString(msgid, interpolation);
};
